import SmallDivision from './SmallDivision';
export default SmallDivision;
